export default __webpack_public_path__ + "static/media/item4.b26904af.png";